// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__nS7kp","container__slider":"Carousel_container__slider__zKtDv"};